import type { Tagged } from 'type-fest';
import { UniqueId } from '../UniqueId';

export type _Role = {
  id: _Role.Id;
  key: string;
  name: string;
  description?: string;
  isPreset: boolean;
};

// 1.3億回生成したときの衝突確率が1%
// こちらのサイトの計算で計算 => https://zelark.github.io/nano-id-cc/
const uuidGenerator = UniqueId.GetFactory(10);

export namespace _Role {
  export type Id = Tagged<UniqueId, 'organizationRoleId'>;
  export namespace Id {
    export const Generate = () => uuidGenerator.generate() as Id;
    export const FromString = (id: string): Id => uuidGenerator.FromString(id) as Id;
  }

  export type Props = {
    id: string;
    key: string;
    name: string;
    description?: string;
    isPreset: boolean;
  };
  export const Construct = (props: Props): _Role => {
    return {
      id: Id.FromString(props.id),
      key: props.key,
      name: props.name,
      description: props.description,
      isPreset: props.isPreset,
    };
  };

  // biome-ignore lint/correctness/noUnusedVariables: FIXME
  namespace Create {
    export type Props = Pick<_Role, 'key' | 'name' | 'description' | 'isPreset'>;
  }
  const Create = (props: Create.Props): _Role => {
    return {
      id: Id.Generate(),
      key: props.key,
      name: props.name,
      description: props.description,
      isPreset: props.isPreset,
    };
  };

  const presets = [
    { key: 'admin', name: '管理者', description: '組織の管理・設定ができます' },
    { key: 'member', name: 'メンバー', description: '組織の閲覧ができます' },
  ];
  export const CreatePresets = (): _Role[] => {
    return presets.map((props) => Create({ ...props, isPreset: true }));
  };

  export const PresetFromKey = (key: string): Pick<_Role, 'key' | 'name' | 'description'> | undefined => {
    return presets.find((p) => p.key === key);
  };
}
